__turbopack_context__.v({
  "iconWrapper": "uqQtkW_iconWrapper",
  "innerContainer": "uqQtkW_innerContainer",
  "section": "uqQtkW_section",
  "subtitle": "uqQtkW_subtitle",
  "textWrapper": "uqQtkW_textWrapper",
  "title": "uqQtkW_title",
  "wrapper": "uqQtkW_wrapper",
});
